import React, { PropTypes } from 'react';
import { connect } from 'react-redux';

import DurationSetPill from './DurationSetPill';
import TimerPill from './TimerPill';

class ShowPill extends React.Component {

    constructor(props, context) {
        super(props, context);
        
        this.pill = {}
        
        if (this.props.getLog) 
            this.props.getLog(this);          
    }

    // OTHER METHODS

    getRef = () => {
        return this.refs.pill;
    }
    
    handlePopoverClose = () => {
        if (this.pill.handlePopoverClose) //timer pills will not have this function
            this.pill.handlePopoverClose();
    }

    // RENDER METHOD

    render = () => {
        if (this.props.logEntry === null)
            return null;

        if (this.props.logEntry.timer)
            return <TimerPill
                        getPill = {(yourself) => {this.pill = yourself}}
                        {...this.props}
                    />;
        else
            return <DurationSetPill
                        getPill = {(yourself) => {this.pill = yourself}}
                        {...this.props}
                    />;
    }
}

ShowPill.propTypes = {
    draggable: PropTypes.bool,
    id: PropTypes.number,
    logEntries: PropTypes.array,
    logEntry: PropTypes.object,
    returnKeymaster: PropTypes.func,
    smartPopoverPlacement: PropTypes.bool,
    tasks: PropTypes.array,
    timesheet: PropTypes.object
};

export default connect()(ShowPill);



/** WEBPACK FOOTER **
 ** ./src/app/components/ShowPill.js
 **/